/**
 * @Author: HJK
 * @Date: 2023-09-04 17:21:05
 * @LastEditTime: 2023-12-15 13:27:57
 * @LastEditors: HJK
 * @Description: 根据用户支付状态和权限配置(后台管理的[考务管理 / 开启条件]中)决定是否允许进行四种操作：学习、作业、考试、补考。级别比人脸识别高
 */
import * as Request from "../common/request";
import { getStudentInfoKeyForRoleTag } from "../common/ulit";

const GET = Request.get;
const baseUrl = Request.baseUrl;

class UsePayStatus {
    /*******
     * @description: 根据学生id查询学生是否缴费
     * @method GET
     * @params {string} studentId
     */
    static getPayStatusPath = baseUrl + "/api/onlinePay/getPayStatusByParam.do";
    /*******
     * @description: 获取配置在后台的四种权限，例如：已缴费才能学习
     * @method GET
     */
    static getConfigPath = baseUrl + "/jlw/teachingPlanCourse/setStartConditionNotCheck.json";
    static payStatus = false;//学生缴费状态
    static payConfig = {//配置在后台的四种权限
        study: false,//是否已缴费才能学习
        work: false,//是否已缴费才能作业
        exam: false,//是否已缴费才能考试
        reExam: false//是否已缴费才能补考
    };
    static studentId = undefined;

    constructor() {
    }

    static async init() {
        await this.getStudentId();
        const status = await this.getPayStatus();
        const config = await this.getConfig();
        console.log('获取到的config 支付', config);

        this.payStatus = status;
        this.payConfig = config;
        // console.log('class UsePayStatus 设置状态成功', status, config);
        return { status, config }
    }

    static async getPayStatus() {
        const status = await GET(this.getPayStatusPath, { studentId: this.studentId });
        return !!status.data
    }

    static async getStudentId() {
        const studentInfoKeyForRoleTag = getStudentInfoKeyForRoleTag();
        const cacheInfo = JSON.parse(sessionStorage.getItem(studentInfoKeyForRoleTag));
        this.studentId = cacheInfo && cacheInfo.studentId;
    }

    static async getConfig() {
        const res = await GET(this.getConfigPath);
        const studentPayCondition = res && res.data && res.data.studentPayCondition;
        console.log('get>>>>>>studentPayCondition', studentPayCondition);

        if (res.code == 0 && studentPayCondition) {
            const fieldArr = studentPayCondition.split('_').map(it => {
                if (it === '0' || it === 0) {
                    return false;
                } else {
                    return true;
                }
            });//[学习，作业，正考，补考]
            return {
                study: fieldArr[0],
                work: fieldArr[1],
                exam: fieldArr[2],
                reExam: fieldArr[3]
            }
        } else {
            return {};
        }

    }


}


export default async () => {
    const { status, config } = await UsePayStatus.init();
    const { study, work, exam, reExam } = config;
    return {
        payStatus: status,
        canStudy: study,
        canWork: work,
        canExam: exam,
        canRepealExam: reExam
    }
}



// WEBPACK FOOTER //
// ./src/utils/usePayStatus.js